import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Content from '../../../layout/Content';
import HolidayListForm from './HolidayListForm';
import { HOLIDAY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { postHolidayList } from '../../../../actions';

const toNullableValue = (value) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  return value;
};

export const buildHolidayListBody = (formValues) => {
  const holidays = Array.isArray(formValues.holidayList)
    ? formValues.holidayList
    : [];

  return holidays
    .filter((holiday) => holiday && holiday.holidayDate && holiday.name)
    .map((holiday) => ({
      holidayDate: holiday.holidayDate,
      name: holiday.name.trim(),
      description: toNullableValue(holiday.description),
    }));
};

const NewHoliday = ({ breadcrumbs, dispatchPostHolidayList }) => {
  const onSubmit = (formValues) => {
    const body = buildHolidayListBody(formValues);

    dispatchPostHolidayList(body);
  };

  const content = <HolidayListForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevos Feriados"
      content={content}
    />
  );
};

NewHoliday.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostHolidayList: PropTypes.func.isRequired,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Feriados',
      href: HOLIDAY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostHolidayList: postHolidayList,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewHoliday);